import isDevelopment from './isDevelopment'

export default (communitySlug) => {
  if (!communitySlug || typeof communitySlug !== 'string') {
    throw new Error('Please pass a community slug as string')
  }

  if (isDevelopment && process.env.INFOWIJS_HOSTNAME_HOY) {
    return process.env.INFOWIJS_HOSTNAME_HOY.toLowerCase().replace('[subdomain]', communitySlug)
  }

  const tld = process.env.INFOWIJS_TLD || (isDevelopment && 'test') || 'nl'

  return `https://${communitySlug}.hoyapp.${tld}`
}
